// extracted by mini-css-extract-plugin
export default {"starRating":"UdariS","starIcon":"rDytt9","starIconActive":"g2lSuD","size-30":"k8X_Nr"};